import {
  SOURCE_ID_TYPE_FILE,
  SOURCE_ID_TYPE_URL,
  STORE_KEY_ID_LIST,
  STORE_KEY_LIST
} from 'Constants/index'
import {
  beContentProviderApiCountContents,
  beContentProviderGetListOfContents
} from 'Api/beContentProvider'
import {
  beContentInsertSource,
  beContentSourceApiGetSearchSourceActivity,
  beContentSourceApiGetSourceActivity,
  beContentSourceApiUpdateSourceFromFile,
  beContentSourceGetListOfStatus,
  beContentSourceGetSource,
  beContentsSourceApiUpdateSource,
  beContentUpdateContents
} from 'Api/beContentSource'
import { beListGetList, beListGetListOfNlList } from 'Api/beListApi'
import { fromUTCtoZoneFormatted, storeGet } from 'mailup-react-helpers'
import axios from 'axios'
import {
  beCampaignsBuilderGetArrayOfListsByIdSource,
  beCampaignsBuilderGetCampaignsByIdSource,
  beCampaignsSetArrayOfListsByIdSource
} from 'Api/beCampaign'

export const getSourceById = async (idSource) => {
  const res = await beContentSourceGetSource(idSource)
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beCampaignsBuilderGetArrayOfListsByIdSource(idSource)
  let isShared = false
  let sharedLists = [idList]

  if (result.length) {
    isShared = result.findIndex((id) => id !== idList) !== -1
    sharedLists = result
  }

  if (res) {
    if (res.SourceType === SOURCE_ID_TYPE_URL) {
      const { frequencyType, hoursUpdateFreq, minutesUpdateFreq } =
        getFrequencyDataFromFrequencyString(res.UpdateFrequency)
      return {
        name: res.SourceName,
        url: res.SourceAddress,
        updateDate: res.UpdateDate,
        urlDisabled: true,
        updateFrequency: {
          frequencyString: res.UpdateFrequency,
          frequencyType,
          hoursUpdateFreq,
          minutesUpdateFreq,
          stopUpdate: !res.IsEnabled
        },
        updateType: res.UpdateType,
        isShared,
        sharedLists,
        idType: res.SourceType,
        isEnabled: res.IsEnabled
      }
    } else if (res.SourceType === SOURCE_ID_TYPE_FILE) {
      return {
        name: res.SourceName,
        updateDate: res.UpdateDate,
        updateType: res.UpdateType,
        isShared,
        sharedLists,
        idType: res.SourceType,
        isEnabled: res.IsEnabled
      }
    }
  }

  return {
    name: undefined,
    updateDate: undefined,
    updateType: undefined
  }
}

export const getSourceActivity = async (idSource, params) => {
  const res = await beContentSourceApiGetSearchSourceActivity(idSource, params)
  if (res) {
    return { items: res.Items }
  }
  return { items: [] }
}

export const getContents = async (idSource) => {
  const res = await beContentProviderApiCountContents(idSource)
  if (res) {
    return { contents: res.Contents, totalItems: res.TotalItems }
  }

  return { contents: [], totalItems: 0 }
}

export const getListData = async () => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const listData = await beListGetList(idList)

  return listData
}

export const getListOfStatus = async (idSource, idType) => {
  const params = {
    pageSize: idType === SOURCE_ID_TYPE_FILE ? 5 : 10
  }

  const res = await beContentSourceGetListOfStatus(idSource, params)
  if (res) {
    return { items: res.Items }
  }
  return { items: [] }
}

export const getLastSourceActivity = async (idSource) => {
  const params = {
    PageSize: 1,
    PageNumber: 1
  }

  const lastActivity = await beContentSourceApiGetSearchSourceActivity(
    idSource,
    params
  )
  if (lastActivity) {
    return { item: lastActivity.Items[0] }
  }
  return { item: [] }
}

export const getLastUpdateContents = async (idSource) => {
  const { TimeZoneCode: tzcode } = storeGet(STORE_KEY_LIST)
  const lastUpdate = await beContentSourceGetListOfStatus(idSource)

  if (lastUpdate.TotalItems) {
    const updateDate = lastUpdate.Items[0].UpdateDate
    const formattedDate = fromUTCtoZoneFormatted(
      updateDate,
      tzcode,
      'YYYY-MM-DD'
    )
    const formattedHour = fromUTCtoZoneFormatted(updateDate, tzcode, 'HH:mm')
    return { updateDate: formattedDate, updateTime: formattedHour }
  }
  return { updateDate: '', updateTime: '' }
}

export async function uploadFile(file, idSource, updateType) {
  const data = new FormData()
  data.append('UserFilename', file.name)
  data.append('UpMode', updateType || 1)
  data.append('UpFile', file)
  const res = await beContentSourceApiUpdateSourceFromFile(idSource, data)
  return res.IdActivity
}

export async function getCsv(url) {
  return new Promise((resolve, reject) => {
    const options = {
      headers: {
        'Content-Type': 'csv'
      }
    }
    axios
      .get(url, options)
      .then((response) => {
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const getUserLists = async () => {
  const result = await beListGetListOfNlList({
    force: true,
    PageSize: 0,
    PageNumber: 0,
    orderBy: 'Id',
    orderDescending: false
  })

  if (result.TotalItems > 0) {
    const lists = result.Items.map(({ IdList, Name }) => ({
      value: IdList,
      label: `${IdList} - ${Name}`
    }))

    return { lists }
  }
  return { lists: [] }
}

export const getSelectAll = async (idSource) => {
  const listShared = await beCampaignsBuilderGetArrayOfListsByIdSource(idSource)
  if (listShared.length) {
    return { selectAll: listShared[0] === 0 }
  }

  return { selectAll: false }
}

export const getBlockedLists = async (idSource) => {
  const result = await beCampaignsBuilderGetCampaignsByIdSource(idSource)

  if (result.TotalItems > 0) {
    const lists = Array.from(
      new Set(result.Items.map((campaign) => campaign.IdList))
    )
    return { blockedLists: lists }
  }
  return { blockedLists: [] }
}

export const saveSharedLists = async (idSource, listIds) => {
  const result = await beCampaignsSetArrayOfListsByIdSource(idSource, {
    ArrayOfListId: listIds
  })
  return result
}

export async function getListOfContents(idSource) {
  const result = await beContentProviderGetListOfContents(idSource)
  return result
}

export const updateSource = async (data) => {
  const { idSource, idType, name, url, updateFrequency } = data

  let params
  const commonParams = {
    SourceType: idType,
    SourceName: name
  }

  if (idType === SOURCE_ID_TYPE_FILE) {
    params = {
      ...commonParams,
      UpdateType: 0,
      SourceAddress: '',
      IsEnabled: true
    }
  } else {
    params = {
      ...commonParams,
      UpdateType: 2,
      UpdateFrequency: updateFrequency.frequencyString,
      IsEnabled: !updateFrequency.stopUpdate,
      SourceAddress: url
    }
  }

  const result = await beContentsSourceApiUpdateSource(idSource, params)

  return result
}

export const insertSource = async (data) => {
  const { idType, name, url, updateFrequency } = data

  const params = {
    SourceType: idType,
    SourceName: name,
    UpdateFrequency: updateFrequency.frequencyString,
    IsEnabled: true,
    SourceAddress: idType === SOURCE_ID_TYPE_URL ? url : '',
    UpdateType: idType === SOURCE_ID_TYPE_URL ? 1 : 0
  }

  const result = await beContentInsertSource(params)
  return result
}

export const updateContents = async (idSource) => {
  const params = {
    trace_activity: true
  }
  const result = await beContentUpdateContents(idSource, params)

  if (result) {
    return result.IdActivity
  }

  return null
}

export const getUpdatedSourceActivity = async (idSource, idActivity) => {
  const res = await beContentSourceApiGetSourceActivity(idSource, idActivity)

  if (res) {
    return res
  }
  return null
}

export const download = (
  fileContent,
  fileName,
  mimeType,
  stringify = false
) => {
  const element = document.createElement('a')
  element.href = `data:${mimeType},${encodeURIComponent(
    stringify ? JSON.stringify(fileContent) : fileContent.data
  )}`
  element.download = fileName
  document.body.appendChild(element)
  element.click()
  element.parentNode.removeChild(element)
}

const getFrequencyDataFromFrequencyString = (str) => {
  let frequencyType, hoursUpdateFreq, minutesUpdateFreq
  if (str.startsWith('0 */')) {
    frequencyType = 3
    hoursUpdateFreq = parseInt(str.slice(4, -6)) // rimuove caratteri '0 */${hoursUpdateFreq} * * *' !== hoursUpdateFreq
    minutesUpdateFreq = 15
  } else if (str.startsWith('*/10')) {
    frequencyType = 1
    hoursUpdateFreq = 6
    minutesUpdateFreq = 15
  } else if (str.startsWith('*/')) {
    frequencyType = 2
    hoursUpdateFreq = 6
    minutesUpdateFreq = parseInt(str.slice(2, -8)) // rimuove caratteri '*/${minutesUpdateFreq} * * * *' !== minutesUpdateFreq
  } else {
    frequencyType = 1
    hoursUpdateFreq = 6
    minutesUpdateFreq = 10
  }

  return {
    frequencyType,
    hoursUpdateFreq,
    minutesUpdateFreq
  }
}
